<div class="modal-content">
  <div class="text-right" style="cursor: pointer" (click)="closeModal()">
    <mat-icon>close</mat-icon>
  </div>

  <div class="content">
    <div class="row">
      <!-- Q88 File Upload -->
      <div class="col-md-4">
        <label><strong>Q88 File (.pdf)</strong></label>
        <div class="file-preview">
          {{ selectedQ88File?.name || "No file selected" }}
        </div>
      </div>
      <!-- Main File Upload -->
      <div class="col-md-4">
        <label><strong>Main File (.xlsx)</strong></label>
        <div class="file-preview">
          {{ selectedMainFile?.name || "No file selected" }}
        </div>
      </div>
      <!-- JSON File Upload -->
      <div class="col-md-4">
        <label><strong>JSON File <span style="font-weight: normal; font-size: 11px; color: #555;">(Optional - skips
              Extractor)</span></strong></label>
        <div class="file-preview">
          {{ selectedJsonFile?.name || "No file selected" }}
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-md-4">
        <button class="btn btn-primary w-100" (click)="q88FileInput.click()">
          Choose Q88 File
        </button>
        <input type="file" hidden #q88FileInput (change)="onQ88FileSelected($event)" accept=".pdf" />
      </div>

      <!-- Main File Upload -->
      <div class="col-md-4">
        <button class="btn btn-primary w-100" (click)="mainFileInput.click()">
          Choose Main File
        </button>
        <input type="file" hidden #mainFileInput (change)="onMainFileSelected($event)"
          accept=".xlsx, .xls, .xlsm, .csv" />
      </div>

      <!-- JSON File Upload -->
      <div class="col-md-4">
        <button class="btn btn-info text-white w-100" (click)="jsonFileInput.click()">
          Choose JSON File
        </button>
        <input type="file" hidden #jsonFileInput (change)="onJsonFileSelected($event)" accept=".json" />
      </div>
    </div>
  </div>
  <div class="button-container mt-4">
    <button class="btn btn-light hover-button mail" (click)="submitClick()">
      Submit
    </button>
  </div>
</div>